import React from 'react';
import { useSelector } from 'react-redux';
import Prize from './components/prize/Prize';
import styles from './prizes.css';


/**
 *
 * @type {React.NamedExoticComponent<{readonly fontFamilyH2?: *, readonly contentColor?: *}>}
 */

const Prizes = React.memo( ( { contentColor, fontFamilyH2 } ) => {

    const { calendar: { prizes, settings: { appearance } }, localization: { content } } = useSelector( ( state ) => state );
    return (
        <div className={ styles.wrapper } style={ appearance && {
            ...appearance.font_style,
            color: appearance.inner_background ? '': contentColor.dark,
            backgroundColor: appearance.inner_background ? appearance.inner_background : 'rgba(0, 0, 0, .5)'
        } }>
            <h3 style={ fontFamilyH2 } className={ styles.title }>{ content && content.calendar.prizes }</h3>
            { prizes && prizes.map( (prize, id )=> <
                Prize
                key={ id }
                prize={ prize }/> ) }
        </div>
    );
} );

export default Prizes;